// English-only, non-clinical navigation and question prompts for the unlisted
// Waiting for Surgery review journey. No symptom collection, clinical triage,
// personalised health plans, urgency classification or monitoring.
export const WAITING_SUPPORT_CHOICES = Object.freeze([
  {
    id: 'next',
    label: 'What happens next?',
    description: 'Understand the waiting-list process',
    target: 'waiting-list',
    icon: 'calendar',
  },
  {
    id: 'wellbeing',
    label: 'Looking after myself',
    description: 'Explore health and wellbeing support',
    target: 'looking-after-health',
    icon: 'heart',
  },
  {
    id: 'questions',
    label: 'I have a question',
    description: 'Choose questions to save for your team',
    target: 'questions',
    icon: 'question',
  },
  {
    id: 'concerns',
    label: "I'm worried",
    description: 'Find out where to ask for help',
    target: 'health-changes',
    icon: 'phone',
  },
]);
export const WAITING_SUPPORT_COPY = Object.freeze({
  heroDescription: "Waiting for surgery can feel uncertain. Find trusted information, prepare for conversations with your hospital team and take things at your own pace.",
  eyebrow: 'Know Your Care · Hospital Journey',
  pageTitle: 'While You Wait for Surgery',
  localInformationFor: 'Local information for',
  yourHospitalLabel: 'your hospital',
  englishOnlyNotice: 'This preview is currently available in English only. No translations have been clinically approved. Please ask your hospital team for an interpreter or information in a format you can understand.',
  importantInformationAria: 'Important information about this guide',
  draftGuideTitle: 'Draft guide — not approved for patient use',
  generalInformationTitle: 'General information, not clinical advice',
  draftGuideWarning: 'This unlisted guide is available for review only. It has no approved local safety-netting contacts. Do not distribute it to patients until your hospital has approved and published its information.',
  urgentChangeAdvice: 'If your health changes or worsens, contact a healthcare professional rather than waiting for surgery. For urgent advice when you are unsure where to go, contact NHS 111. For a life-threatening emergency, call 999.',
  journeySectionsHeading: 'Your waiting-list journey',
  journeySectionsInstruction: 'Read the sections in any order, and return whenever you need to.',
  ofLabel: 'of',
  getHelpHeading: 'Where to get help',
  contactHospitalTeam: 'Contact your hospital team',
  noApprovedContact: 'Use the contact details given by your own hospital team. No local contact has been approved for this preview.',
  urgentLinkIntro: 'For urgent medical help when you are unsure where to go, use ',
  urgentLinkOutro: '. In a life-threatening emergency, call ',
  hospitalLinksHeading: 'Information and support from your hospital',
  exploreSurgeryJourney: 'Explore the general surgery journey',
  localLinksPublished: 'Trust-specific links are published following local review.',
  previewNoLocalApproval: 'Unlisted review preview · no local clinical approval recorded.',
  loadingLocalInformation: 'Checking local information…',
  needsHeading: 'What would help you today?',
  needsDescription: 'Choose what matters most to you. These options open information, not a symptom assessment.',
  navigationTitle: 'Jump to a section',
  partLabel: 'Part',
  resourceDisclosure: 'Explore six wellbeing topics',
  resourceDisclosureDescription: 'Activity, eating well, smoking, alcohol, mental wellbeing and sleep',
  questionHeading: 'Questions you might like to ask',
  questionDescription: 'Select the questions that matter to you, then save them in My Care to take to your next appointment.',
  saveSelected: 'Save selected questions to My Care',
  saved: 'Saved to My Care',
  viewMyCare: 'Open My Care',
  writeOwn: 'Write your own question or note in My Care',
  noSelection: 'Choose at least one question to save.',
  savedFeedback: 'Your selected questions have been saved on this device in My Care.',
  saveError: 'Unable to save on this device. You can write the questions down or open My Care to try again.',
  privateNote: 'Questions and notes stay on this device unless you choose to share them with someone.',
  questions: [
    'Who should I contact if my symptoms change while I am waiting?',
    'Is there a health or prehabilitation service that might be suitable for me?',
    'How will I hear about my preassessment or operation date?',
    'What should I bring to preassessment?',
    'Can I ask for an interpreter, accessible information or other support?',
    'Where can I find my hospital’s instructions for preparing for surgery?',
    'Who can I talk to about worries or practical arrangements while I wait?',
  ],
});
